/**
 * Created by mac on 7/26/18
 */

const RiddlesKrakenFeastWindow = CleverappsWindow.extend({
    onWindowLoaded: function (mission, options) {
        this.mission = mission;

        options = options || {};
        this.options = options;

        const offer = this.offer = cleverapps.offerManager.findOffer({ mission: mission.type });

        this._super({
            name: "RiddlesKrakenFeastWindow",
            content: new RiddlesKrakenFeastView(this),
            noBackground: true,
            closeButton: false,
            styles: cleverapps.styles.RiddlesKrakenFeastWindow.window,
            notCloseByTouchInShadow: true,
            openSound: bundles.krakenfeast_window.urls.feast_window_effect,
            showSound: bundles.monster.urls.tentacles_spawn_effect,
            offerWindowButton: offer ? {
                text: Messages.get(`FeastMissionWindow.${mission.getName()}.offer`),
                offerType: offer.type,
                onClicked: this.onOfferClicked.bind(this),
                bundle: "krakenfeast_window",
                badgeText: Messages.get(`FeastMissionWindow.${mission.getName()}.offerBadge`)
            } : undefined
        });

        this.mission.updateCompetitionResults();

        this.mission.logEvent(Mission.EVENTS.MISSION_WINDOW);
    },

    onShow: function () {
        this._super();

        this.mission.runningCompetition.table.showUp();
    },

    onClose: function () {
        this.mission.runningCompetition.updateShownPlace();
        this.mission.updateMissionIcon();

        this._super();
    },

    onOfferClicked: function () {
        ComponentMap.get(this, WindowComponent).closeWindow();
        cleverapps.offerManager.showOfferWindow(this.offer);
    },

    getPerson: function () {
        return cleverapps.styles.RiddlesKrakenFeastWindow.person;
    },

    listBundles: function () {
        return ["krakenfeast_window"];
    }
});

cleverapps.styles.RiddlesKrakenFeastWindow = {
    window: {
        windowShowUpAnimation: undefined
    },

    person: {
        left: {
            role: "knight",
            emotion: "happy"
        }
    }
};
